import { Dialog } from "@in/component-library";
import { Grid, Icon, Text, VerticalSpacer } from "@innovationnorway/lighthouse-components";
import React, { useEffect, useRef, useState } from "react";
import { sendSiteimproveEvent } from "../../../utils/sendSiteimproveEvent";
import { useLayout } from "../../hooks/useLayout";
import { GettingStartedCards } from "../gettingStartedCards/gettingStartedCards";
import "./addApplicationsCard.scss";

interface AddApplicationsCardProps {
  fastForwardUrl: string;
  projectAssistantUrl: string;
}

const AddApplicationsCard = ({ fastForwardUrl, projectAssistantUrl }: AddApplicationsCardProps) => {
  const { translations } = useLayout();
  const [showModal, setShowModal] = useState(false);
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if (showModal) {
      dialogRef.current?.showModal();
    } else {
      dialogRef.current?.close();
    }
  }, [showModal]);

  const onCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      {/*TODO: Change to lighthouse 3.0 ActionCard when onclick is added.*/}
      <div
        className="applicationCard"
        onClick={() => {
          sendSiteimproveEvent(`MyPage-newApplicationBeta`, "NewApplicationClicked", "Opened new application modal");
          setShowModal(true);
        }}
        tabIndex={0}
        onKeyUp={(e) => {
          e.stopPropagation();
          if (e.code === "Enter") {
            sendSiteimproveEvent(`MyPage-newApplicationBeta`, "NewApplicationClicked", "Opened new application modal");
            setShowModal(true);
          }
        }}
      >
        <div className="applicationCard__container">
          <Text className="applicationCard__title" variant="subheading">
            {translations.checkForHelp}
          </Text>
          <VerticalSpacer size="s" />
          <Text variant="paragraph">{translations.privatePersonApplicationDescription}</Text>
          <VerticalSpacer size="m" />
          <Text variant="paragraph">{translations.oneWayInDescription}</Text>
        </div>

        <div className="applicationCard__addButton__icon">
          <Icon className="in-card-action__action-icon" prefix="fasr" iconName="arrow-right" size="s" />
        </div>
      </div>
      <Dialog
        aria-label="Add applications"
        ref={dialogRef}
        onClose={onCloseModal}
        closeButton={{
          onClick: () => dialogRef.current?.close(),
          "aria-label": translations.close
        }}
      >
        <Grid>
          <GettingStartedCards fastForwardUrl={fastForwardUrl} projectAssistantUrl={projectAssistantUrl} />
        </Grid>
      </Dialog>
    </>
  );
};

export default AddApplicationsCard;
